import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "17",
  fill: "none",
  viewBox: "0 0 18 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M8.045 1.092c.29-.94 1.62-.94 1.91 0l1.188 3.843a1 1 0 0 0 .955.704h3.946c.956 0 1.367 1.214.607 1.795l-3.277 2.503a1 1 0 0 0-.348 1.09l1.23 3.984c.288.93-.788 1.68-1.562 1.09l-3.087-2.359a1 1 0 0 0-1.214 0l-3.087 2.359c-.774.59-1.85-.16-1.563-1.09l1.231-3.984a1 1 0 0 0-.348-1.09L1.349 7.434c-.76-.58-.35-1.795.607-1.795h3.946a1 1 0 0 0 .955-.704z"
    }, null, -1)
  ]))]))
}
export default { render: render }